import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
const { __ } = wp.i18n;
import {PanelBody,Panel,RangeControl,SelectControl,InputControl,ToggleControl,TextControl,TextareaControl,Button,Icon} from "@wordpress/components";
import {imageUpload} from "./imageUploadPlaceholder";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

const ALLOWED_BLOCKS = ["core/list","core/paragraph","theme-blocks/linkline"];
const TEMPLATE = [["core/paragraph"]];


registerBlockType('theme-blocks/bio-popup',{
    title:'Biography Popup',
    category:'theme-blocks',
    icon:'text',
    attributes:{
      image:{type:'object',default:{id:0,url:`${VARIABLES.templateurl}/images/sectionContact2.png`}},
      imageRight:{type:'boolean',default:false},
      name:{type:'string'},
      title:{type:'string'},
      text:{type:'string'},
      bio:{type:'string'}
      
    },
    edit:function({attributes,setAttributes}){


      return (<Fragment>
        <InspectorControls>
          <Panel>
            <PanelBody title="Popup Content" initialOpen={true}>
              <TextareaControl value={attributes.bio} onChange={(v)=>setAttributes({bio:v})}/>
            </PanelBody>
          </Panel>
        </InspectorControls>
        <div className="biopopup">
          <div className="image">
            {imageUpload({
              value:attributes.image,
              onSelect:(media)=>{
                setAttributes({image:media})
              }
            })}
          </div>
          <RichText tagName="h2" value={attributes.name} placeholder="Name" onChange={(v)=>setAttributes({name:v})}/>
          <RichText tagName="i" value={attributes.title} placeholder="Title/Positions" onChange={(v)=>setAttributes({title:v})}/>
          <div className="popup">
            <div className="content">
              <div className="close"><button>&times;</button></div>
              <div className="main">
              <RichText tagName="h2" value={attributes.name} placeholder="Name" onChange={(v)=>setAttributes({name:v})}/>
              <RichText tagName="i" value={attributes.title} placeholder="Title/Positions" onChange={(v)=>setAttributes({title:v})}/>
              </div>
            </div>
          </div>
        </div>
      </Fragment>);
    },
    save:function({attributes}){
        return ( <div className="biopopup">
        <div className="image">
          <img src={attributes.image?.url}/>
        </div>
        <RichText.Content tagName="h2" value={attributes.name}/>
        <RichText.Content tagName="i" value={attributes.title}/>
        <div className="popup">
          <div className="content">
            <div className="close"><button>&times;</button></div>
            <div className="main">
              <div className="image">
                <img src={attributes.image?.url}/>
              </div>
              <RichText.Content tagName="h2" value={attributes.name}/>
              <RichText.Content tagName="i" value={attributes.title}/>
              <RichText.Content tagName="p" value={attributes.bio?.replace(/\n/g,"<br/>")}/>
            </div>
          </div>
        </div>
      </div>);
     
    }
});
 